import * as React from 'react';
import {Box, Card, CardContent, Typography} from "@mui/material";

interface IBusinessProfileProps {
    final: any[],
}

const TradeAgreements = ({final}: IBusinessProfileProps) => {
    const value = final.reduce((partialSum: number, submission: any) => partialSum + Number(submission.trade_agr_num_t1), 0)

    return (
        <Card className="chart-container">
            <CardContent>
                <div className="space-y-4">
                    <Typography>
                        Total number of trade agreements
                    </Typography>
                    <Box
                        sx={{
                            p: 1,
                            border: '1px solid grey',
                            textAlign: 'right',
                            fontSize: '1rem',
                            backgroundColor: 'rgb(243, 244, 246)',
                        }}
                    >
                        <div>
                            { value }
                        </div>
                    </Box>

                </div>
            </CardContent>
        </Card>
    );
};

export default TradeAgreements;
